import Vue from 'vue'
import Router from 'vue-router'
import {CONFIG_AUTHORIZATION_CONNECT_PARTNER} from "@/constant";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Users
const UserResetPass = () => import('@/views/users/UserResetPass')
const UserAdd = () => import('@/views/users/UserAdd')
const UserUpdate = () => import('@/views/users/UserUpdate')
const UsersList = () => import('@/views/users/UsersList')
const UserProfile = () => import('@/views/users/UserProfile')
const UserLogin = () => import('@/views/users/UserLogin')
const UserVerifyOTP = () => import('@/views/users/UserConfirmOTP')
const UserRegister = () => import('@/views/users/UserRegister')
const CategoryList = () => import('@/views/users/CategoryList')

// Connect SSO Org
const ConnectSSOOrg = () => import('@/views/connect_sso_org/ConnectOrg')
const PendingConfigAuthentication = () => import('@/views/connect_sso_org/PendingConfigAuthentication')

// Views - Pages
const PageNotifySSO = () => import('@/views/pages/PageNotifySSO')
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

// // Thread
// const ThreadList = () => import('@/views/thread/ThreadList')

//System
const SystemList = () => import('@/views/systems/SystemList')
const SystemAdd = () => import('@/views/systems/SystemAdd')
const SystemUpdate = () => import('@/views/systems/SystemUpdate')

// User action Log
const UserActionLog = () => import('@/views/user_action_logs/UserActionLogList')

Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  base: process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Trang chủ',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Bảng điều khiển',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/user-management',
          redirect: '/user-management/managed-users',
          name: 'Quản lý tài khoản',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-users',
              name: 'Danh sách tài khoản',
              component: UsersList
            },
            {
              path: 'managed-position',
              name: 'Danh sách chức vụ',
              component: CategoryList
            },
            {
              path: 'new',
              name: 'Thêm mới tài khoản',
              component: UserAdd
            },
            {
              path: 'managed-users/:id',
              name: 'Cập nhật tài khoản',
              component: UserUpdate
            },
            {
              path: 'my-profile',
              name: 'Thông tin tài khoản',
              component: UserProfile
            }
          ]
        },
        {
          path: '/system-management',
          redirect: '/system-management/managed-system',
          name: 'Quản lý hệ thống',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-system',
              name: 'Danh sách hệ thống',
              component: SystemList
            },
            {
              path: 'new',
              name: 'Thêm mới hệ thống',
              component: SystemAdd
            },
            {
              path: 'managed-system/:id',
              name: 'Cập nhật hệ thống',
              component: SystemUpdate
            },
            {
              path: 'action-log',
              name: 'Nhật kí hệ thống',
              component: UserActionLog
            }
          ]
        },
      ]
    },
    // {
    //   path: '/login.html',
    //   name: 'UserLogin',
    //   component: UserLogin,
    // },
    {
      path: '/login.html',
      name: 'UserLogin',
      component: CONFIG_AUTHORIZATION_CONNECT_PARTNER ? ConnectSSOOrg : UserLogin,
    },
    {
      path: '/pending.html',
      name: 'PendingConfigAuthentication',
      component: PendingConfigAuthentication,
    },
    {
      path: '/verify.html',
      name: 'UserVerifyOTP',
      component: UserVerifyOTP,
    },
    {
      path: '/register.html',
      name: 'UserRegister',
      component: UserRegister,
    },
    {
      path: '/required.html',
      name: 'PageNotifySSO',
      component: PageNotifySSO,
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'reset-password.html',
          name: 'UserResetPass',
          component: UserResetPass
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },
  ]
})

export default router
